import { ChangeEvent, useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";



const usePreviewBranch = () => {
    const {readFirestore} = useFirestore();
    const [search, setSearch] = useState<string>('');
    const [lists, setLists] = useState<any[]>([]);
    const [searchedLists, setSearchedLists] = useState<any[]>([]);
    useEffect(() => {
        getBranchList();
    }, [])

    const onChange = (e:ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    }

    useEffect(() => {
        const searchedItems = lists.filter((item) => item["name"].includes(search));
        setSearchedLists(searchedItems);
        // eslint-disable-next-line
    }, [search])


    const getBranchList = async() => {
        const branch_list = await readFirestore("User/Auth/Branch").then(res => {
            const list:any[] = [];
            const docs = res.docs;
            const docs_length = res.docs.length;
            for(let i = 0; i < docs_length; i++){
                const doc = docs[i];
                list.push({id:doc.id, name:doc.data().name})
            }
            return list;
        })
        setSearchedLists(branch_list)
        setLists(branch_list)
    }

    return {search, searchedLists, onChange}
}

export default usePreviewBranch;